import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import {
  constructionAsset,
  constructionEquipment,
  constructionSafety,
  logisticsAsset,
  medicalPatient,
  medicalWaste,
  officeAsset,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'Công trường xây dựng hiện đại là một môi trường phức tạp và tiềm ẩn nhiều rủi ro. Do vậy việc duy trì an toàn và bảo vệ người lao động là vô cùng quan trọng. Để đạt được mục tiêu này, công nghệ tiên tiến mang tên Hệ thống theo dõi vị trí thời gian thực (RTLS) đang được ứng dụng phổ biến và rộng rãi.',
  keywords:
    'Quản lý an toàn lao động, xây dựng thông minh, an toàn công trường, RTLS, quan ly an toan lao dong, xay dung thong minh, an toan cong truong, rtls.',
  ogSite: 'Giải pháp quản lý an toàn thông minh toàn diện chỉ trong một',
  title: 'Giải pháp quản lý an toàn thông minh toàn diện chỉ trong một',
  ogUrl: 'https://orbro.io/vi/blog/smartSafety',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDyroUx1vmR8ckUGMDATiid3Dh8um-T9HPZwlPIYFAVQZ6gAqtjkC9yRmKCzc1E4y9OSYTPb_LCkF_SEylO00Rky0eS7weV0HFegyoQFnuWtZS4dJcgZhXg7NgKbB-lJHqoWX9iWFXOLGYRCck7Pzm9SecNQohk3gkJMABfK0W7SOahk5A_CpImCa6ZeYjnPrnJxJzATWPOAu_GUAv9tunvWcaHzwHNFGzd4wmKkzNRlpgiqTGmxGDiF1tnkU43_8zJ8Af3YPglR8V_Y8nr6hIKD0r_deC5eKuX9NhdkGi3_MwlH_6ID7fHAUY_4D8ay4UBjdHdIY39ZO5qmVVydqF4YA7_e2S6LGjkfGuhX06LkrzYLkNj0kAaBXMND1BhVSI-Zb-GpDot9xVAkg6mS0dhnTHGd4Dvh5P1F6CkjB2DJ8ZytwXnQJyQtOzhgYFcstok9388wIUDLs51CPoeUsytegmLUUG2NVsxXLfpB4yqeUz4gTQjH3WvGUQP3GKJkEsZ-fuzdaF3pTx9LLKB_xDvIeFhzmb4fONSHT2U9U_QEJjLCzt-NCZxHK3YK_xeHCQhB9h_8KLnCTSz8LgKKy80N4IfOpROiCh_oyYTiWXzhcWHWWh-OEvPtgY2xoCN2CtcClws0U3t-xRH5NQ9bsFsLU_41jxHLmULeU4UjUBfE50lAbgEhTIIi45ibRyNlruRzOzOsd3M129XYQM4F49mvW0c-MCe1D8fhLFbSg3TLCoO6lNHzOuGk5AhawFY6LXRmsNWIAf_orzFCaByHj8FIYhInRqA3JGuwUkGOVkqTrb2pAeqRb2Y0mO0a7Q5yuK7IEEVD6nNCJ9QrWtOBE8yYzrXVf54N7SL9aQz5ZCP4SCwp27j3V85cmk5dx-ZyDGiapVFg1rNA7Mwnx4L3F0eKNcRZzT9WWMWBXLD61fLbIfCcvoENjVSYEPO8VN5ipvNWSNwV5iHjace_sdYEzNMByEmrEjVt4slthi5itRPgSKrrgq1CQDcdZsSh1ToMCeUzPAcoPW9rnjGh8tngE7-VrPH5QLHldQu9mQy9skU-nCfY8A2DF9RRzB6So10votLNIb3bGaL-HSF5s0TOU8HlSAg2EKU6gM4LGwPjg5HztDXDoJyuRiBQcw6myNwpypRu3MPsD4EhS-uhn49VM4TVxsZMw6DJc5CXmZHhghyxX9GJyf2uHKWVOOzLkeJm2641BA8ZOpxpeg1bfNczrS9qVJDgRpzye_uh7uqihmtRlKAWH9tA2nouewAzocUyrzii7EX46YkP2GHg7DY_L_42aHc9EyTXPpGw3LDlJXHQ3sQ44RUyNV1EFE99w27XRmnxr_8YlZD9pegnY5GWNBiU35BwROQDKDsEzgKunAYgEhg3EspT4nJl4E_j19DHxsNer97Yudk2jhRWZ1QTcFWH67Ew8lCLdVw_yY0CqKWuMZK0o_379BLJt_dJIO5GVE-vhMEqdEN1zCUUp8yqBaruMbTm-_IfSHGOgQa4uue05eTTj-RcxLbAz-mRT8gzDo4yeOWNDBw4NsMtbQr-YOf89LvIvhhch-ND74zLC0KeIz5gM7VfV0VD4MkKBw=w2049-h1228',
  ogType: 'website',
  date: '2023-10-04',
  tag1: '#Quanlyantoanlaodong',
  tag2: '#Xaydungthongminh',
  tag3: '#Antoancongtruong',
  tag4: '#Rtls',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Công trường xây dựng hiện đại là một môi trường phức tạp và tiềm ẩn nhiều rủi ro. Do vậy việc duy trì an toàn và bảo vệ người lao động là vô cùng quan trọng. Để đạt được mục tiêu này, công nghệ tiên tiến mang tên Hệ thống theo dõi vị trí thời gian thực (RTLS) đang được ứng dụng phổ biến và rộng rãi. Hệ thống giúp quản lý an toàn cho người lao động tại công trường một cách dễ dàng hơn. Bài viết này sẽ tìm hiểu cách công nghệ RTLS góp phần nâng cao an toàn cho người lao động như thế nào.',
      dot: '',
    },
    {
      head: 'Giới thiệu công nghệ RTLS',
      subHead: '',
      desc: `RTLS là viết tắt của 'Real-Time Location System', nghĩa là hệ thống theo dõi vị trí thời gian thực. Công nghệ này cho phép xác định và giám sát chính xác vị trí của các yếu tố di động như người lao động hoặc thiết bị. Hệ thống RTLS sử dụng GPS, RFID (Nhận dạng qua tần số vô tuyến), UWB (Băng tần siêu rộng), Bluetooth, sóng siêu âm và các cảm biến khác để theo dõi vị trí của người lao động.`,
      dot: '',
    },
    {
      head: 'Ưu điểm của RTLS đối với An toàn lao động',
      subHead: 'Phòng ngừa tai nạn',
      desc: 'Hệ thống RTLS xác định vị trí người lao động trong thời gian thực, giúp phát hiện sớm các nguy cơ va chạm hoặc tình huống nguy hiểm tiềm ẩn. Ví dụ, trong quá trình vận hành cần cẩu, hệ thống có thể phát hiện sự tiếp cận gần của người lao động khác hoặc thiết bị và gửi cảnh báo để phòng ngừa tai nạn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Theo dõi tình trạng người lao động',
      desc: 'RTLS có thể giám sát hoạt động của người lao động và theo dõi tình trạng sức khỏe hoặc mức độ mệt mỏi của họ. Nếu người lao động có dấu hiệu kiệt sức, hệ thống có thể hướng dẫn họ nghỉ ngơi hợp lý hoặc cảnh báo họ rời khỏi khu vực làm việc nguy hiểm.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ứng phó tình huống khẩn cấp',
      desc: 'Trong trường hợp người lao động gặp tình huống khẩn cấp, hệ thống RTLS cung cấp thông tin vị trí chính xác, giúp rút ngắn thời gian cần thiết cho việc cứu hộ hoặc sơ cứu. Điều này làm tăng khả năng cứu sống người lao động.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nhật ký công việc và báo cáo',
      desc: 'Hệ thống RTLS ghi lại hoạt động của người lao động và tạo nhật ký công việc. Thông qua đó, có thể tối ưu hóa lịch trình làm việc và nâng cao năng suất. Ngoài ra, khi xảy ra tai nạn, hệ thống ghi lại thông tin liên quan, hỗ trợ cho việc điều tra và báo cáo tai nạn.',
      dot: '',
    },
    {
      head: 'Các Trường hợp Áp dụng RTLS',
      subHead: 'Công trường xây dựng',
      desc: 'Công trường xây dựng tồn tại nhiều yếu tố nguy hiểm và đòi hỏi sự phối hợp của nhiều người lao động. Hệ thống RTLS theo dõi thời gian thực các thiết bị như cần cẩu, xe nâng, xe ben và người lao động để tạo ra một môi trường làm việc an toàn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nhà máy và ngành sản xuất',
      desc: 'Trong lĩnh vực nhà máy và sản xuất, RTLS cũng được sử dụng để theo dõi vị trí người lao động và quản lý hàng tồn kho. Qua đó, có thể tối ưu hóa quy trình sản xuất và nâng cao hiệu quả sản xuất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Logistics và kho bãi',
      desc: 'Trong ngành logistics và kho bãi, hệ thống RTLS được ứng dụng để theo dõi hàng tồn kho, xác định vị trí người lao động trong kho và tối ưu hóa quy trình xuất nhập hàng cũng như giao nhận.',
      dot: '',
    },
    {
      head: 'Lời kết',
      subHead: '',
      desc: 'Công nghệ RTLS là một công cụ mạnh mẽ giúp nâng cao an toàn và năng suất cho người lao động tại công trường xây dựng cũng như các lĩnh vực công nghiệp khác. Công nghệ này mang lại nhiều lợi ích to lớn cho người quản lý hiện trường và người lao động thông qua các chức năng đa dạng như phòng ngừa tai nạn, theo dõi tình trạng người lao động, ứng phó tình huống khẩn cấp, tạo nhật ký công việc và báo cáo. Chúng ta kỳ vọng vào sự phát triển của công nghệ RTLS trong ngành xây dựng và các lĩnh vực công nghiệp khác trong tương lai, đồng thời cần ghi nhớ rằng việc không ngừng nỗ lực nâng cao an toàn cho người lao động là điều cần thiết.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/vi/enterprise/construction/equipment',
      },
    ],
  },
};
